import React from 'react';
import { Row, Col, Dropdown, MenuItem, ButtonToolbar, Button } from 'react-bootstrap';
import { Data, Toolbar } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import Spinner from '../../../Widgets/spinner';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { DisabledSelection, Selection } from '../../selection';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { Translate } from 'react-redux-i18n';
import { fetchActiveCustomersOptions } from '../../../../actions/customers_actions';
import DatePicker, { DisabledDatePicker } from '../../datePicker';
import InputField, { DisabledInputField } from '../../inputField';
import TextareaField from '../../TextareaField';
import { DateFormatter, TimeFormatter } from '../../dateFormat';
import moment from 'moment';
import axios from 'axios';
import { CUSTOMER_LOG_URL } from '../../../../actions/url';
import { debounce } from 'lodash';
import { setValue } from '../../../../actions/sales_actions';

const { Selectors } = Data;
let renderReleaseRadio = props => {
  return (
    <div className="form-group">
      <div className="col-xs-6">
        <label>
          <input
            {...props.input}
            type="radio"
            value="true"
            checked={props.input.value === "true"}
          />
          <Translate value="yes" />
        </label>
      </div>
      <div className="col-xs-6">
        <label>
          <input
            {...props.input}
            type="radio"
            value="false"
            checked={props.input.value === "false"}
          />
          <Translate value="no" />
        </label>
      </div>
    </div>
  )
}
class CustomerLogModal extends React.Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedRows: [],
      currentRow: null,
      filters: {},
      currentCustomer: null,
      limit: 10,
      pages: 0,
      totalRows: 0,
      currentPage: 1,
    }
    this.token = localStorage.getItem('token');
  }
  componentDidMount() {
    if (this.props.customers.length === 0) {
      this.props.fetchActiveCustomersOptions();
    } else {
      if (this.props.currentCustomer && this.props.currentCustomer[0]) {
        const currentCustomer = this.props.currentCustomer[0];
        this.props.setValue('CustomerLogForm', 'SearchCustomer', {value: currentCustomer.CustomerNum, label: currentCustomer.Name});
      }
    }
    this.fetchCustomerLogs();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.SearchCustomer != this.props.SearchCustomer) {
      if (nextProps.SearchCustomer) {
        const currentCustomer = this.props.customers.find(item => item.CustomerNum === nextProps.SearchCustomer.value);
        if (currentCustomer) {
          this.setState({
            currentCustomer,
            filters: {
              ...this.state.filters,
              customer_num: currentCustomer.CustomerNum,
            }
          });
        }
      } else {
        const {filters} = this.state;
        delete filters.customer_num;
        this.setState({
          filters: {...filters},
          currentCustomer: null,
        });
      }
    }
    if (nextProps.DateFrom != this.props.DateFrom) {
      if (nextProps.DateFrom) {
        this.setState({
          filters: {
            ...this.state.filters, 
            date_from: moment(nextProps.DateFrom).format('YYYY-MM-DD')
          },
        });
      } else {
        const {filters} = this.state;
        delete filters.date_from;
        this.setState({
          filters: {...filters},
        });
      }
    }
  } 
  
  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevState.filters !== this.state.filters) {
      this.fetchCustomerLogs();
    }
    if (prevState.selectedRows !== this.state.selectedRows) {
      if (this.state.selectedRows.length > 0) {
        this.fetchCustomerLogDetail();
      } else {
        this.resetForm();
        this.setState({
          currentRow: null,
        })
      }
    }
    if (this.props.customers && this.props.customers !== prevProps.customers) {
      if (this.props.currentCustomer && this.props.currentCustomer[0]) {
        const currentCustomer = this.props.currentCustomer[0];
        this.props.setValue('CustomerLogForm', 'SearchCustomer', {value: currentCustomer.CustomerNum, label: currentCustomer.Name});
      }
    }
  }

  fetchCustomerLogs = (page = 0) => {
    axios.get(CUSTOMER_LOG_URL, {
      params: {page: page + 1, limit: this.state.limit, ...this.state.filters},
      headers: { Authorization: `Bearer ${this.token}`},
    }).then(response => {
      this.setState({
        rows: response.data.data,
        pages: response.data.pages,
        totalRows: response.data.counts,
        currentPage: page
      });
    });
  }
  
  fetchCustomerLogDetail = () => {
    const row = this.state.selectedRows[0];
    axios.get(`${CUSTOMER_LOG_URL}${row.id}`, {
      headers: { Authorization: `Bearer ${this.token}`},
    }).then(response => {
      const currentRow = response.data;
      this.setState({
        currentRow,
      });
      const currentCustomer = this.props.customers
        .filter(customer => customer.Customer_id === currentRow.Customer_id)
        .map(customer => ({value: customer.CustomerNum, label: customer.Name}));
      if (currentCustomer.length > 0) {
        this.props.setValue('CustomerLogForm', 'Customer', currentCustomer[0]);
      }
      this.props.setValue('CustomerLogForm', 'Attn', currentRow.Attn);
      this.props.setValue('CustomerLogForm', 'CallBackDate', currentRow.CallBack_Date ? moment(currentRow.CallBack_Date) : null);
      this.props.setValue('CustomerLogForm', 'Date', moment(currentRow.Create_Date));
      this.props.setValue('CustomerLogForm', 'CallBackTime', currentRow.CallBack_Time ? moment(currentRow.CallBack_Time).format('HH:mm') : null);
      this.props.setValue('CustomerLogForm', 'Time', moment(currentRow.Create_Time).format('HH:mm'));
      this.props.setValue('CustomerLogForm', 'Content', currentRow.Content);
      this.props.setValue('CustomerLogForm', 'Description', currentRow.Description);
      this.props.setValue('CustomerLogForm', 'Store_No', currentRow.Store_No);
      this.props.setValue('CustomerLogForm', 'Release', currentRow.Release + '');
    });
  }

  getCustomers() {
    const Customers = [];
    this.props.customers.forEach((customer) => {
      Customers.push({ value: customer.CustomerNum, label: customer.Name });
    });
    return Customers;
  }

  renderSearchCustomers = () => {
    const renderComponent = () => {
      if (this.props.customersIsLoading) return <Col xs={4}><Spinner style={{margin: 0, width: '60px'}}/></Col>;
      const Customers = this.getCustomers();
      return <Field name={"SearchCustomer"} component={Selection} options={Customers} />
    }
    return (
      <div style={{width: '33.3333%', marginBottom: '10px', float: 'left'}}>
        <Col xs={3}>
          <label className="inlineLabel" >
            <Translate value="customer" />
          </label>
        </Col>
        <Col xs={8}>{renderComponent()}</Col>
      </div>
    );
  }
  renderCustomers = editable => {
    const renderComponent = () => {
      if (this.props.customersIsLoading) return <Col xs={4}><Spinner style={{margin: 0, width: '60px'}}/></Col>;
      const Customers = this.getCustomers();
      return <Field name={"Customer"} component={editable ? Selection : DisabledSelection} options={Customers} />
    }
    return (
      <div style={{width: '33.3333%', marginBottom: '10px', float: 'left'}}>
        <Col xs={3}>
          <label className="inlineLabel" >
            <Translate value="customer" /><span className="asteriksReq">*</span>
          </label>
        </Col>
        <Col xs={8}>{renderComponent()}</Col>
      </div>
    );
  }
  
  renderDateFilter = () => {
    return (
      <Col xs={3}>
        <Col xs={5}>
          <label className="inlineLabel" >
            <Translate value="date_from" />
          </label>
        </Col>
        <Col xs={7}><Field name="DateFrom" component={DatePicker} /></Col>
      </Col>
    )
  }
  
  resetForm = () => {
    this.props.setValue('CustomerLogForm', 'Customer', initialValues.Customer);
    this.props.setValue('CustomerLogForm', 'Attn', initialValues.Attn);
    this.props.setValue('CustomerLogForm', 'CallBackDate', initialValues.CallBackDate);
    this.props.setValue('CustomerLogForm', 'Date', initialValues.Date);
    this.props.setValue('CustomerLogForm', 'CallBackTime', initialValues.CallBackTime);
    this.props.setValue('CustomerLogForm', 'Time', moment().format('HH:mm').toString());
    this.props.setValue('CustomerLogForm', 'Content', initialValues.Content);
    this.props.setValue('CustomerLogForm', 'Description', initialValues.Description);
    this.props.setValue('CustomerLogForm', 'Store_No', initialValues.Store_No);
    this.props.setValue('CustomerLogForm', 'Release', initialValues.Release);
  }
  
  resetSelection = () => {
    const rows = [...this.state.rows].map(row => ({...row, isSelected: false}))
    this.setState({
      selectedRows: [],
      rows
    });
  }
  
  handleSubmit = debounce((formData) => {
    if (!this.state.currentRow) {
      const currentCustomer = this.props.customers
        .filter(customer => customer.CustomerNum === formData.Customer.value);
      axios.post(CUSTOMER_LOG_URL, {
        Attn: formData.Attn,
        Content: formData.Content,
        Description: formData.Description,
        Release: formData.Release === 'true',
        Store_No: formData.Store_No,
        Customer_id: currentCustomer[0].Customer_id,
        CreateTime: moment(moment(formData.Date).format('YYYY-MM-DD') + ' ' + formData.Time),
        CallBackTime: formData.CallBackDate && formData.CallBackTime 
          ? moment(moment(formData.CallBackDate).format('YYYY-MM-DD') + ' ' + formData.CallBackTime) 
          : undefined,
      }, {
        headers: { Authorization: `Bearer ${this.token}`},
      }).then(response => {
        if (response.status === 200) {
          alert(response.data);
          this.resetSelection();
          this.fetchCustomerLogs();
        }
      }).catch(err => {
        alert(err.message);
      })
    } else {
      axios.put(`${CUSTOMER_LOG_URL}${this.state.currentRow.id}`, {
        Attn: formData.Attn,
        Content: formData.Content,
        Description: formData.Description,
        Release: formData.Release === 'true',
        Store_No: formData.Store_No,
        CallBackTime: formData.CallBackDate && formData.CallBackTime 
          ? moment(moment(formData.CallBackDate).format('YYYY-MM-DD') + ' ' + formData.CallBackTime) 
          : null,
      }, {
        headers: { Authorization: `Bearer ${this.token}`},
      }).then(response => {
        if (response.status === 200) {
          alert(response.data);
          this.resetSelection();
          this.fetchCustomerLogs();
        }
      }).catch(err => {
        alert(err.message);
      })
    }
  }, 200);
  
  handleCancel = () => {
    this.props.handleClose && this.props.handleClose();
  }
  
  handleDelete = () => {
    if(confirm("Are you sure you want to remove item?")) {
      axios.delete(`${CUSTOMER_LOG_URL}${this.state.currentRow.id}`, {
        headers: { Authorization: `Bearer ${this.token}`},
      }).then(response => {
        if (response.status === 200) {
          alert(response.data);
          this.resetSelection();
          this.fetchCustomerLogs(this.state.currentPage);
        }
      }).catch(err => {
        alert(err.message);
      })
    }
  }
  
  renderSaveBtn = () => {
    const {handleSubmit, Attn, Content, Description, Customer, Date, Time} = this.props;
    const enableSave = !!Attn && !!Content && !!Description && !!Customer.value && !!Date && !!Time;
    if (this.state.currentRow) {
      return <Button
        bsStyle="success"
        onClick={handleSubmit(formProps => {
          this.handleSubmit(formProps)
        })}
        disabled={!enableSave}
      >
        <em className="fa fa-save marginRightStyle" /><Translate value="save" />
      </Button>
    }
    return <Button
      bsStyle="primary"
      onClick={handleSubmit(formProps => {
        this.handleSubmit(formProps)
      })}
      disabled={!enableSave}
    >
      <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
    </Button>
  }
  
  render() {
    const columns = [
      {
        key: 'Create_Date',
        name: <Translate value="date" />,
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'Create_Time',
        name: <Translate value="time" />,
        width: 80,
        resizable: true,
        sortable: false,
        filterable: true,
        formatter: TimeFormatter
      },
      {
        key: 'Customer_Name',
        name: <Translate value="customer" />,
        width: 110,
        resizable: true,
        sortable: false,
        filterable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        width: 180,
        resizable: true,
        sortable: false,
        filterable: true,
      },
      {
        key: 'CallBack_Date',
        name: <Translate value="callback_date" />,
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'CallBack_Time',
        name: <Translate value="callback_time" />,
        width: 80,
        resizable: true,
        sortable: false,
        filterable: true,
        formatter: TimeFormatter
      },
      {
        key: 'Attn',
        name: <Translate value="attn" />,
        width: 80,
        resizable: true,
        sortable: false,
        filterable: true,
      },
      {
        key: 'Store_No',
        name: <Translate value="store_no" />,
        width: 100,
        resizable: true,
        sortable: false,
        filterable: true,
      },
      {
        key: 'User_Name',
        name: <Translate value="user" />,
        width: 100,
        resizable: true,
        sortable: false,
        filterable: true,
      },
    ];
    const getRows = () => {
      return Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      const rows = getRows();
      return rows[rowIdx];
    }
    const handleFilterChange = filter => {
      let newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    }
    const onRowsSelected = (rows) => {
      let newRows = getRows().map(row => ({...row, isSelected: false}));
      rows.forEach(r => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({ rows: newRows, selectedRows: rows.map(row => row.row) });
    }
    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      rows.forEach((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    }

    const handleOnPageChange = data => {
      this.fetchCustomerLogs(data.selected);
    }

    const handleGridSort = (sortColumn, sortDirection) => {
      const sortMap = {
        Create_Date: 'CreateTime',
        CallBack_Date: 'CallBackTime',
      }
      if (sortDirection === 'ASC') {
        const filters = {...this.state.filters};
        if(sortMap[sortColumn]) {
          filters.sort = sortMap[sortColumn];
          this.setState({filters});
        }
      }
      if (sortDirection === 'DESC') {
        //-
        const filters = {...this.state.filters};
        if(sortMap[sortColumn]) {
          filters.sort = `-${sortMap[sortColumn]}`;
          this.setState({filters});
        }
      }
      if (sortDirection === 'NONE') {
        //unset
        const filters = {...this.state.filters};
        delete filters.sort;
        this.setState({filters});
      }
    }
    
    return <div>
      <Row>
        {this.renderSearchCustomers()}
        <Col xs={3}>
          {this.state.currentCustomer ? this.state.currentCustomer.Name : ''}
        </Col>
        <Col xs={2}>
          {
            this.state.currentCustomer ? 
              this.state.currentCustomer.Telephone 
              ? `Phone: ${this.state.currentCustomer.Telephone}` 
              : this.state.currentCustomer.Cellphone 
                ? `Phone: ${this.state.currentCustomer.Cellphone}` 
                : '' 
              : ''
          }
        </Col>
        {this.renderDateFilter()}
      </Row>
      <Row>
        <ReactDataGrid
          // toolbar={<Toolbar enableFilter />}
          // onAddFilter={handleFilterChange}
          onGridSort={handleGridSort}
          columns={columns}
          rowGetter={rowGetter}
          rowsCount={getSize()}
          minHeight={300}
          rowHeight={40}
          headerRowHeight={45}
          enableRowSelect='single'
          rowSelection={{
            showCheckbox: true,
            onRowsSelected,
            onRowsDeselected,
            selectBy: {
                isSelectedKey: 'isSelected'
            }
          }}
        />
      </Row>
      <Row>
        <Col xs={6} style={{display: 'flex'}}>
          <div style={{ width: '600px' }} id="react-pagination">
            <ReactPaginate
              previousLabel={<Translate value="prev_page" />}
              nextLabel={<Translate value="next_page" />}
              containerClassName={'pagination'}
              activeClassName={'active'}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              pageCount={this.state.pages}
              onPageChange={handleOnPageChange}
              forcePage={this.state.currentPage}
            />
          </div>
        </Col>
      </Row>
      <div style={{width: '100%', borderBottom: '2px solid #FFA000', margin: '10px auto'}}></div>
      <Row>
        <div style={{width: '18%', float: 'left'}}>
          <Col xs={3}>
            <label className="col-xs-1 inlineLabel">
              <Translate value="date" /><span className="asteriksReq">*</span>
            </label>
          </Col>
          <Col xs={9}><Field name="Date" component={this.state.currentRow ? DisabledDatePicker : DatePicker} /></Col>
        </div>
        <div style={{width: '15%', float: 'left'}}>
          <Col xs={5}>
            <label className="col-xs-1 inlineLabel">
              <Translate value="time" /><span className="asteriksReq">*</span>
            </label>
          </Col>
          <Col xs={7}>
            <Field 
              name="Time" 
              component={
                this.state.currentRow 
                  ? DisabledInputField 
                  : InputField
              } 
              placeholder={
                this.state.currentRow 
                  ? undefined 
                  : 'EX:08:30'
              }
            />
          </Col>
        </div>
        <div style={{width: '22%', float: 'left'}}>
          <Col xs={4}>
            <label className="col-xs-3 inlineLabel">
              <Translate value="callback_date" />
            </label>
          </Col>
          <Col xs={8}><Field name="CallBackDate" component={DatePicker} /></Col>
        </div>
        <div style={{width: '20%', float: 'left'}}>
          <Col xs={5}>
            <label className="col-xs-2 inlineLabel">
              <Translate value="callback_time" />
            </label>
          </Col>
          <Col xs={5}><Field name="CallBackTime" component={InputField} placeholder={'EX:08:30'}/></Col>
        </div>
        <div style={{width: '25%', float: 'left'}}>
          <Col xs={3}>
            <label className="col-xs-1 inlineLabel">
              <Translate value="release" />
            </label>
          </Col>
          <Col xs={7}><Field name="Release" component={renderReleaseRadio} /></Col>
        </div>
      </Row>
      <Row>
        {this.renderCustomers(!this.state.currentRow)}
        <div style={{width: '20%', float: 'left', marginRight: '10px', marginBottom: '10px'}}>
          <Col xs={5}>
            <label className="inlineLabel">
              <Translate value="store_no" />
            </label>
          </Col>
          <Col xs={7}><Field name="Store_No" component={InputField} /></Col>
        </div>
        <div style={{width: '22%', float: 'left', marginBottom: '10px'}}>
          <Col xs={4}>
            <label className="inlineLabel">
              <Translate value="contact" /><span className="asteriksReq">*</span>
            </label>
          </Col>
          <Col xs={8}><Field name="Attn" component={InputField} /></Col>
        </div>
      </Row>
      <Row>
        <div style={{width: '100%', float: 'left', marginBottom: '10px'}}>
          <Col xs={1}>
            <label className="inlineLabel">
              <Translate value="description" /><span className="asteriksReq">*</span>
            </label>
          </Col>
          <Col xs={10}>
            <Field name="Description" component={InputField} />
          </Col>
        </div>
      </Row>
      <Row>
        <div style={{width: '100%', float: 'left', marginBottom: '10px'}}>
          <Col xs={1}>
            <label className="inlineLabel">
              <Translate value="content" /><span className="asteriksReq">*</span>
            </label>
          </Col>
          <Col xs={10}>
            <Field name="Content" component={TextareaField} />
          </Col>
        </div>
      </Row>
      <Row>
        <Col xs={12}>
          <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px', float: 'right' }}>
            {this.renderSaveBtn()}
            <Button
              bsStyle="warning"
              onClick={this.handleCancel}
            >
              <em className="fa fa-close" /><Translate value="cancel" />
            </Button>
            {this.state.currentRow && <Button
              bsStyle="danger"
              onClick={this.handleDelete}
            >
              <em className="fa fa-trash" /><Translate value="delete" />
            </Button>}
          </ButtonToolbar>
        </Col>
      </Row>
    </div>
  }
}
const customerLogModal = reduxForm({
  form: 'CustomerLogForm',
})(CustomerLogModal);
const selector = formValueSelector('CustomerLogForm');
const initialValues = {
  SearchCustomer: null,
  Customer: null,
  Date: moment(),
  DateFrom: null,
  Time: moment().format('HH:mm').toString(),
  CallBackDate: null,
  CallBackTime: null,
  Release: 'false',
  Store_No: '',
  Attn: '',
  Description: '',
  Content: '',
};
const mapStateToProps = state => {
  const SearchCustomer = selector(state, 'SearchCustomer');
  const DateFrom = selector(state, 'DateFrom');
  const Content = selector(state, 'Content');
  const Description = selector(state, 'Description');
  const Date = selector(state, 'Date');
  const Time = selector(state, 'Time');
  const Attn = selector(state, 'Attn');
  const Customer = selector(state, 'Customer');
  return {
    SearchCustomer,
    DateFrom,
    Content,
    Description,
    Date,
    Time,
    Attn,
    Customer,
    initialValues: {
      ...initialValues
    },
    customers: state.customers.options,
    customersIsLoading: state.customers.loadingOptions,
  }
}
export default connect(mapStateToProps, {
  fetchActiveCustomersOptions,
  setValue,
})(customerLogModal);


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/CustomerLogModal.jsx